import type { ComboboxOptionObjectInterface, ComboboxOptionType } from '@zillow/constellation-10';
import { Box, FormField, FormHelp, Label } from '@zillow/constellation-10';

import TimeZoneDropdownSelect from '../../../../TimeZoneDropdownSelect';
import type { TimeZoneIds } from '../../../../../constants/TourCalendar';

type TimeZoneBodyProps = {
  timeZone?: TimeZoneIds;
  onSelectTimeZone: (timeZone: TimeZoneIds) => void;
};

const TimeZoneBody = ({ timeZone, onSelectTimeZone }: TimeZoneBodyProps) => {
  const handleOptionSelect = (comboBoxOption: ComboboxOptionType) => {
    const option = comboBoxOption as ComboboxOptionObjectInterface;
    const timeZoneId = option.value as TimeZoneIds;

    if (timeZoneId) {
      onSelectTimeZone(timeZoneId);
    }
  };

  return (
    <Box data-testid="TimeZoneBody" css={{ display: 'flex', flexDirection: 'column', gap: 'loose' }}>
      <FormField
        label={<Label size="lg">Property time zone</Label>}
        description={
          <FormHelp>
            This helps ensure that your tour availability matches what’s provided to interested renters
          </FormHelp>
        }
        control={
          <TimeZoneDropdownSelect
            timeZone={timeZone}
            handleOptionSelect={handleOptionSelect}
            disableTimeZoneSelection={false}
          />
        }
        required
      />
    </Box>
  );
};

export default TimeZoneBody;
